export const cssStyles = `
.contract-body {
  width: 100%;
  font-family: Arial, sans-serif;
}

.contract-header-uk-content {
  width: 50%;
}

.contract-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.contract-first-column-purchase {
   width: 170px;
}
.contract-td {
  padding: 4px;
  border: 1px solid black;

}
.contract-left-col {
  width: 100%;  
}

/* */
.contract-agreement-table-header{
  margin-bottom: 2px;
  margin-top: 0px;
  text-align: left;
}
.contract-agreement-table-header.first {
  text-align: right;
}
.contract-parties {
  width: 100%;
  margin-top: 20px;
}

.contract-align-center{
    text-align: center;
}

.contract-border-thick {
  border-left: 2px solid black;
}

.contract-table{
  border-collapse: collapse;
  width: 100%;
}
.contract-third-space-fr { width: 30.5%; }
.contract-third-space-de { width: 30.5%; }
.contract-third-space-uk { width: 33.5%; }

.contract-city-right-fr { width: 38.5%; }
.contract-city-right-de { width: 39.5%; }
.contract-city-right-uk { width: 33.5%; }

.contract-second-space{
  width: 30.5%;
  max-width: 30.5%;
}
.contract-half-space{
  width: 50%;
}

.contract-quater-space{
  width: 25%;
}
.contract-med-space{
  width: 18%;
}

.contract-min-space{
  width: 15%;
}

.contract-three-quater-space{
  width: 75%;
}

.contract-half-quater-space{
 width: 12%;
}

.contract-helper-text {
  font-size: 10px;
  margin-bottom: -10px;
  margin-top: -2px;
}

.contract-small-margin-top{
  margin-top: 5px;
}

.contract-no-margin-top{
  margin-top: -20px;
}

.margin-top-large{
  margin-top: 40px;
}
.margin-top-medium{
 margin-top: 20px;
}
.margin-top-min{
 margin-top: 10px;
}
.page-break{
   page-break-after: always;
}

.contract-min-width{
  min-width: 150px;
}
.contract-min-width-first-table-fr{
  min-width: 230px;
}
.contract-min-width-first-table-de{
  min-width: 186px;
}
.contract-min-width-first-table-uk{
  width: 50%;
}

p {
  font-size: 12px;
  min-height: 12px;
}

.black-box {
  background-color: black !important;
  width: 20px;
  height: 20px;
  margin-left: 20px;
}

.uk-eq-col {
  vertical-align: top;
  word-wrap: break-word;
}
.uk-eq-label {
  font-size: 11px;
  margin: 0;
}
.uk-eq-currency {
  display: flex;
  justify-content: space-between;
}
.uk-w-26 { width: 26%; }
.uk-w-18 { width: 18%; }
.uk-w-13 { width: 13%; }
.uk-w-12 { width: 12%; }
`;
